import fleetApi from "@/lib/fleetApi";
import { todayKey } from "@/lib/time";

const shift = (n) => { const d = new Date(`${todayKey()}T12:00:00`); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };

// Fleet /trips returns only today by default; the live board is today + upcoming.
export async function boardTrips() {
  const [a, b] = await Promise.all([fleetApi.get("/trips?day=today&limit=5000"), fleetApi.get("/trips?day=upcoming&limit=5000")]);
  const m = new Map();
  [...(a.data || []), ...(b.data || [])].forEach((t) => m.set(t.id, t));
  return [...m.values()];
}

// Owners can read the past year via Trip History; other roles only see the board.
export async function wideTrips(isOwner) {
  if (!isOwner) return boardTrips();
  const out = [];
  for (let skip = 0; skip < 5000; skip += 500) {
    const { data } = await fleetApi.get(`/trips/history?start=${shift(-365)}&end=${shift(90)}&limit=500&skip=${skip}`);
    out.push(...(data.trips || []));
    if (out.length >= (data.total || 0) || !(data.trips || []).length) break;
  }
  return out;
}
